import acceptanceDocuments from './acceptanceDocuments';
import accountBalances from './accountBalances';
import accountingTransactions from './accountingTransactions';
import accounts from './accounts';
import accountTypes from './accountTypes';
import aiSearch from './aiSearch';
import archiApps from './archiApps';
import archiAppSections from './archiAppSections';
import archeidos from './archeidos';
import attachments from './attachments';
import avBillingInfos from './avBillingInfos';
import batchOperations from './batchOperations';
import billingInfos from './billingInfos';
import bills from './bills';
import categories from './categories';
import chatGptPrompts from './chatGptPrompts';
import colors from './colors';
import composer from './composer';
import currencyRates from './currencyRates';
import customFields from './customFields';
import downloads from './downloads';
import emailTemplates from './emailTemplates';
import evaluations from './evaluations';
import evaluationSets from './evaluationSets';
import files from './files';
import filters from './filters';
import financeAddresses from './financeAddresses';
import generalLedgers from './generalLedgers';
import images from './images';
import invoices from './invoices';
import itemCategories from './itemCategories';
import items from './items';
import itemTypes from './itemTypes';
import journalRecordImportRows from './journalRecordImportRows';
import journalRecordImports from './journalRecordImports';
import journalRecords from './journalRecords';
import libraries from './libraries';
import lifestyles from './lifestyles';
import materials from './materials';
import menu from './menu';
import messages from './messages';
import modelViewers from './modelViewers';
import operations from './operations';
import pages from './pages';
import payments from './payments';
import permissions from './permissions';
import previewModels from './previewModels';
import products from './products';
import profiles from './profiles';
import projectMemberInvites from './projectMemberInvites';
import projectMembers from './projectMembers';
import projectNotifications from './projectNotifications';
import projects from './projects';
import reports from './reports';
import reportSections from './reportSections';
import results from './results';
import revenueShareItems from './revenueShareItems';
import selectedLifestyles from './selectedLifestyles';
import selectedMaterials from './selectedMaterials';
import selectedProducts from './selectedProducts';
import settings from './settings';
import smartContracts from './smartContracts';
import smartContractExpenseImports from './smartContractExpenseImports';
import sourceFiles from './sourceFiles';
import statuses from './statuses';
import supersetReports from './supersetReports';
import surveys from './surveys';
import tags from './tags';
import taskMemberInvites from './taskMemberInvites';
import taskMembers from './taskMembers';
import taskNotifications from './taskNotifications';
import tasks from './tasks';
import teamInvitations from './teamInvitations';
import teams from './teams';
import teamsUsers from './teamsUsers';
import todoItems from './todoItems';
import transactions from './transactions';
import transactionTags from './transactionTags';
import twinAssets from './twinAssets';
import twinMaterials from './twinMaterials';
import twinParts from './twinParts';
import twins from './twins';
import twinRules from './twinRules';
import twinPublish from './twinPublish';
import ueStreamings from './ueStreamings';
import users from './users';
import whiteboards from './whiteboards';

const models = {
  acceptanceDocuments,
  accountBalances,
  accountingTransactions,
  accounts,
  accountTypes,
  aiSearch,
  archiApps,
  archiAppSections,
  archeidos,
  attachments,
  avBillingInfos,
  batchOperations,
  billingInfos,
  bills,
  categories,
  chatGptPrompts,
  colors,
  composer,
  currencyRates,
  customFields,
  downloads,
  emailTemplates,
  evaluations,
  evaluationSets,
  files,
  filters,
  financeAddresses,
  generalLedgers,
  images,
  invoices,
  itemCategories,
  items,
  itemTypes,
  journalRecordImportRows,
  journalRecordImports,
  journalRecords,
  libraries,
  lifestyles,
  materials,
  menu,
  messages,
  modelViewers,
  operations,
  pages,
  payments,
  permissions,
  previewModels,
  products,
  profiles,
  projectMemberInvites,
  projectMembers,
  projectNotifications,
  projects,
  reports,
  reportSections,
  results,
  revenueShareItems,
  selectedLifestyles,
  selectedMaterials,
  selectedProducts,
  settings,
  smartContracts,
  smartContractExpenseImports,
  sourceFiles,
  statuses,
  supersetReports,
  surveys,
  tags,
  taskMemberInvites,
  taskMembers,
  taskNotifications,
  tasks,
  teamInvitations,
  teams,
  teamsUsers,
  todoItems,
  transactions,
  transactionTags,
  twinAssets,
  twinMaterials,
  twinParts,
  twins,
  twinRules,
  twinPublish,
  ueStreamings,
  users,
  whiteboards
};

export default models;
